import React from 'react';
import { Button, FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTimesCircle,
    faCheckCircle,
    faReply,
} from '@fortawesome/free-solid-svg-icons';
import { BillingStatus } from '../billing/Billing';
import {
    FlexCenterRow,
    SimpleTable,
    FormLabel,
    Textarea,
    Flex,
} from '../common/forms/FormElements';
import CommonContext from '../Common';
import { BillingIssueMessageTypes } from '../billingIssues/BillingIssues';

export default class BillingIssuesWidget extends React.Component {
    static contextType = CommonContext;
    constructor(props) {
        super(props);
        this.state = {
            messages: [],
        };
    }

    onAccept = () => {
        this.props.onAcceptCallback(
            this.props?.billing?.timesheetId,
            this.state.userMessage,
        );
    };

    onAddRejectNotes = () => {
        this.props.onRejectCallback(
            this.props?.billing?.timesheetId,
            this.state.userMessage,
            false,
        );
    };

    onAddReplyNotes = () => {
        this.props.onReplyCallback(
            this.props?.billing?.timesheetId,
            this.state.userMessage,
            false,
        );
    };

    onClose = () => {
        this.context.setFormOpened(false);
        this.props.onCloseCallback();
    };

    onReject = () => {
        this.props.onRejectCallback(
            this.props?.billing?.timesheetId,
            this.state.userMessage,
            true,
        );
    };

    onReply = () => {
        this.props.onReplyCallback(
            this.props?.billing?.timesheetId,
            this.state.userMessage,
            true,
        );
    };

    open = () => {
        this.context.setFormOpened(true);
        this.setState({ userMessage: '' });
    };

    renderMessages = () => {
        const { messages } = this.props;

        return messages.map((message) => (
            <tr key={message.id}>
                <td
                    width="30"
                    style={{ paddingTop: '15px', textAlign: 'center' }}
                >
                    {message.billingIssueMessageTypeId
                        == BillingIssueMessageTypes.Reply && (
                            <FontAwesomeIcon
                                icon={faReply}
                                size="lg"
                                color="blue"
                            />
                        )}
                    {message.billingIssueMessageTypeId
                        == BillingIssueMessageTypes.Rejection && (
                            <FontAwesomeIcon
                                icon={faTimesCircle}
                                size="lg"
                                color="red"
                            />
                        )}
                    {message.billingIssueMessageTypeId
                        == BillingIssueMessageTypes.Accepted && (
                            <FontAwesomeIcon
                                icon={faCheckCircle}
                                size="lg"
                                color="green"
                            />
                        )}
                </td>
                <td width="150">
                    <span style={{ whiteSpace: 'nowrap' }}>
                        {message.createdBy}
                    </span>
                    <br />
                    <span style={{ whiteSpace: 'nowrap' }}>
                        {message.createdOn}
                    </span>
                </td>
                <td>
                    <div style={{ whiteSpace: 'pre-line' }}>
                        {message.notes}
                    </div>
                </td>
            </tr>
        ));
    };

    render() {
        const subcontractorName = this.props?.billing?.subcontractorName;
        const customerNameFormatted = (this.props?.billing?.customerName ?? '')
            + (subcontractorName ? ` - ${subcontractorName}` : '');
        return (
            <>
                <FormGroup>
                    <div
                        className="invoice-details"
                    >
                        <Flex alignItems="center">
                            <FormLabel label="Job Date" />
                            <span
                                className="text-muted ml-2"
                            >
                                {this.props?.billing?.date}
                            </span>
                        </Flex>
                        <Flex alignItems="center">
                            <FormLabel label="Customer" />
                            <span
                                className="text-muted ml-2"
                            >
                                {customerNameFormatted}
                            </span>
                        </Flex>
                        <Flex alignItems="center">
                            <FormLabel label="Contract Number" />
                            <span
                                className="text-muted ml-2"
                            >
                                {this.props?.billing?.contractNumber}
                            </span>
                        </Flex>
                        <Flex alignItems="center">
                            <FormLabel label="Dispatching" />
                            <span
                                className="text-muted ml-2"
                            >
                                {this.props?.billing?.dispatchOfficeName}
                            </span>
                        </Flex>
                        <Flex alignItems="center">
                            <FormLabel label="Timesheets" />
                            <span
                                className="text-muted ml-2"
                            >
                                {this.props?.billing?.timesheetNumber}
                            </span>
                        </Flex>
                        <Flex alignItems="center">
                            <FormLabel label="Work Order" />
                            <span
                                className="text-muted ml-2"
                            >
                                {this.props?.billing?.workOrderNumber}
                            </span>
                        </Flex>
                    </div>

                    <FormLabel
                        htmlFor="messagesTable"
                        label="Messages"
                    />
                    <SimpleTable
                        id="messagesTable"
                        noTopBorder
                        permission="contract"
                        tableHeaderLabels={[
                            {
                                name: ' ',
                            },
                            {
                                name: 'From',
                            },
                            {
                                name: 'Message',
                            },
                        ]}
                        editable={false}
                        entities={this.props.messages}
                        rowRenderer={this.renderMessages}
                        noDataText="No messages found."
                    />
                </FormGroup>

                {this.props?.context === 'rejecting'
                    && this.props?.billing?.billingStatusId
                    == BillingStatus.ReadyToInvoice
                    && this.props?.billing?.invoiceNumber == null && (
                        <>
                            <Textarea
                                label="Rejection Notes"
                                id="userMessage"
                                name="userMessage"
                                onChange={(e) => {
                                    this.setState({
                                        userMessage: e.target.value,
                                    });
                                }}
                                value={this.state.userMessage ?? ''}
                                required
                                placeholder="Enter notes regarding the rejection."
                                maxLength="500"
                                rows="5"
                                error="Notes are required."
                            />
                            <FlexCenterRow className="mb-3">
                                <Button
                                    size="md"
                                    name="reject"
                                    type="button"
                                    color="danger"
                                    onClick={this.onReject}
                                >
                                    Reject
                                </Button>
                            </FlexCenterRow>
                        </>
                    )}

                {this.props?.context === 'rejecting'
                    && this.props?.billing?.billingStatusId == BillingStatus.PendingReview && (
                        <>
                            <Textarea
                                label="Rejection Notes"
                                rows="8"
                                id="userMessage"
                                name="userMessage"
                                onChange={(e) => {
                                    this.setState({
                                        userMessage: e.target.value,
                                    });
                                }}
                                value={this.state.userMessage ?? ''}
                                required
                                placeholder="Enter notes regarding the rejection."
                                maxLength="500"
                                error="If rejecting, notes are required."
                            />

                            <FlexCenterRow className="mb-3">
                                <Button
                                    size="md"
                                    name="accept"
                                    type="button"
                                    color="success"
                                    onClick={this.onAccept}
                                >
                                    Accept
                                </Button>
                                &nbsp;&nbsp;&nbsp;
                                <Button
                                    size="md"
                                    name="reject"
                                    type="button"
                                    color="danger"
                                    onClick={this.onReject}
                                >
                                    Reject
                                </Button>
                            </FlexCenterRow>
                        </>
                    )}

                {this.props?.context === 'rejecting'
                    && this.props?.billing?.billingStatusId == BillingStatus.IssueReject && (
                        <>
                            <Textarea
                                label="Notes"
                                id="userMessage"
                                name="userMessage"
                                onChange={(e) => {
                                    this.setState({
                                        userMessage: e.target.value,
                                    });
                                }}
                                value={this.state.userMessage ?? ''}
                                required
                                placeholder="Add a note"
                                maxLength="500"
                                rows="5"
                                error="Notes are required."
                            />

                            <FlexCenterRow className="mb-3">
                                <Button
                                    size="md"
                                    name="reply"
                                    type="button"
                                    color="success"
                                    onClick={this.onAddRejectNotes}
                                >
                                    Add Note
                                </Button>
                            </FlexCenterRow>
                        </>
                    )}

                {this.props?.context === 'replying'
                    && this.props?.billing?.billingStatusId
                    == BillingStatus.PendingReview
                    && this.props?.billing?.billingStatus != 'Accepted' && (
                        <>
                            <Textarea
                                label="Notes"
                                id="userMessage"
                                name="userMessage"
                                onChange={(e) => {
                                    this.setState({
                                        userMessage: e.target.value,
                                    });
                                }}
                                value={this.state.userMessage ?? ''}
                                required
                                placeholder="Add a note"
                                maxLength="500"
                                rows="5"
                                error="Notes are required."
                            />

                            <FlexCenterRow className="mb-3">
                                <Button
                                    size="md"
                                    name="reply"
                                    type="button"
                                    color="success"
                                    onClick={this.onAddReplyNotes}
                                >
                                    Add Note
                                </Button>
                            </FlexCenterRow>
                        </>
                    )}

                {this.props?.context === 'replying'
                    && this.props?.billing?.billingStatusId
                    != BillingStatus.PendingReview
                    && this.props?.billing?.billingStatus != 'Accepted' && (
                        <>
                            <Textarea
                                label="Reply to Rejection"
                                id="userMessage"
                                name="userMessage"
                                onChange={(e) => {
                                    this.setState({
                                        userMessage: e.target.value,
                                    });
                                }}
                                value={this.state.userMessage ?? ''}
                                required
                                placeholder="Enter notes regarding this reply."
                                maxLength="500"
                                rows="5"
                                error="Notes are required."
                            />

                            <FlexCenterRow className="mb-3">
                                <Button
                                    size="md"
                                    name="reply"
                                    type="button"
                                    color="success"
                                    onClick={this.onReply}
                                >
                                    Reply
                                </Button>
                            </FlexCenterRow>
                        </>
                    )}
            </>
        );
    }
}
